import { CarouselButton, Column, Container, Grid, Row, Separator, useAlignments, useSizes } from 'metrix-common3';
import styled from 'styled-components';

const ButtonContainer = styled(Container)`
    overflow: hidden;
`;

const Footer = ({ query, listPolicies, doReduceQueryElement, doQueryPolicies }) => {
    const alignments = useAlignments();
    const sizes = useSizes();

    const handleLeftClick = () => {
        doReduceQueryElement({ code: 'search', value: true });
        doReduceQueryElement({ code: 'skip', value: query.list.skip - 25 });
        doQueryPolicies();
    };

    const handleRightClick = () => {
        doReduceQueryElement({ code: 'search', value: true });
        doReduceQueryElement({ code: 'skip', value: query.list.skip + 25 });
        doQueryPolicies();
    };

    return (
        <Grid>
            <Row noguttertop>
                <Column>
                    <Separator solid />
                </Column>
            </Row>
            <Row>
                <Column>
                    <ButtonContainer
                        inline
                        fullSize
                        horizontalAlignment={alignments.right}
                        verticalAlignment={alignments.center}
                    >
                        {query.list.skip > 0 && <CarouselButton direction='left' clickEvent={handleLeftClick} />}
                        {listPolicies?.length === 25 && (
                            <CarouselButton direction='right' left={sizes.xs} clickEvent={handleRightClick} />
                        )}
                    </ButtonContainer>
                </Column>
            </Row>
        </Grid>
    );
};

export default Footer;
